var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18.75H11.25C11.9375 18.75 12.5 18.1875 12.5 17.5V15.625H11.25V17.5H3.75V2.49997H11.25V4.37497H12.5V2.49997C12.5 1.81247 11.9375 1.24997 11.25 1.24997H3.75C3.0625 1.24997 2.5 1.81247 2.5 2.49997V17.5C2.5 18.1875 3.0625 18.75 3.75 18.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8688 12.8687L15.1062 10.625H6.25V9.37497H15.1062L12.8688 7.13122L13.75 6.24997L17.5 9.99997L13.75 13.75L12.8688 12.8687Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0f390693e111d2cd1a0a7940ced96e8b.svg";
export { ForwardRef as ReactComponent };